import { Form, Radio, Select } from "antd";
import { useFetchFeePlanRuleSetsQuery } from "features/feePlans/feePlansAPI";
import { useFetchTaxPlanRuleGroupsQuery } from "features/taxPlans/taxPlansAPI";

const REMITTANCE_OPTIONS = [
  {
    label: "Gross",
    value: "gross",
  },
  {
    label: "Net",
    value: "net",
  },
];

const BILLING_OPTIONS = [
  {
    label: "No Balance Forward",
    value: "gross",
  },
  {
    label: "Balance Forward",
    value: "net",
  },
];

const PAYMENT_DELIVERY_METHOD_OPTIONS = [
  {
    label: "Checks",
    value: "checks",
  },
  {
    label: "ACH",
    value: "ach",
  },
];

export default function InvoicesStep() {
  const { data: feePlanRuleSets } = useFetchFeePlanRuleSetsQuery();
  const { data: taxPlanRuleGroups } = useFetchTaxPlanRuleGroupsQuery();
  return (
    <>
      <Form.Item
        name={["invoiceConfig", "feePlanAssignmentRulesetId"]}
        label="Fee Plan Rule Set"
        rules={[{ required: true, message: "Fee plan rule set is required" }]}
      >
        <Select
          options={feePlanRuleSets?.map((ruleSet) => ({ label: ruleSet.name, value: ruleSet.id }))}
        />
      </Form.Item>
      <Form.Item name={["invoiceConfig", "taxPlanRuleGroupId"]} label="Tax Plan Rule Group">
        <Select
          options={[
            {
              label: "Unassigned",
              value: null,
            },
            ...(taxPlanRuleGroups?.map((ruleGroup) => ({
              label: ruleGroup.name,
              value: ruleGroup.id,
            })) ?? []),
          ]}
        />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "principalRemit", "agency"]}
        label="Agency Principal Payment Remit Type"
        rules={[{ required: true, message: "Remit type is required" }]}
      >
        <Select options={REMITTANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "interestRemit", "agency"]}
        label="Agency Interest Payment Remit Type"
        rules={[{ required: true, message: "Remit type is required" }]}
      >
        <Select
          options={REMITTANCE_OPTIONS.map((each) => ({ label: each.label, value: each.value }))}
        />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "feesRemit", "agency"]}
        label="Agency Fees Remit Type"
        rules={[{ required: true, message: "Remit type is required" }]}
      >
        <Select options={REMITTANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "principalRemit", "creditor"]}
        label="Client Principal Payment Remit Type"
        rules={[{ required: true, message: "Remit type is required" }]}
      >
        <Select options={REMITTANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "interestRemit", "creditor"]}
        label="Client Interest Payment Remit Type"
        rules={[{ required: true, message: "Remit type is required" }]}
      >
        <Select options={REMITTANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "feesRemit", "creditor"]}
        label="Client Fees Remit Type"
        rules={[{ required: true, message: "Remit type is required" }]}
      >
        <Select options={REMITTANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "adjustments"]}
        label="Invoice Adjustment Remit Type"
        rules={[{ required: true, message: "Remit type is required" }]}
      >
        <Select options={REMITTANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "billing"]}
        label="Balance Forward"
        tooltip={
          <>
            <p>No Balance Forward - Bill any amount due agency for each invoice separately.</p>
            <p>
              Balance Forward - Deduct any prior invoice amount due agency from next remittance.
            </p>
          </>
        }
        rules={[{ required: true, message: "Invoice billing type is required" }]}
      >
        <Select options={BILLING_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "paymentMethodType"]}
        label="Payment Method"
        tooltip={
          <>
            <p>ACH - Amount due Client to be paid in ACH payments.</p>
            <p>Checks - Amount due Client to be paid via printing checks.</p>
          </>
        }
        rules={[{ required: true, message: "Invoice payment method type is required" }]}
      >
        <Select options={PAYMENT_DELIVERY_METHOD_OPTIONS} popupMatchSelectWidth={false} />
      </Form.Item>
      <Form.Item name={["invoiceConfig", "taxRemit"]} label="Invoice Tax Remit Type">
        <Select options={REMITTANCE_OPTIONS} />
      </Form.Item>
      <Form.Item
        name={["invoiceConfig", "includeChildrenCreditorsInvoices"]}
        label="Include Children Creditors' Invoices"
        tooltip="Does this creditor want to receive invoices for all of their children creditors?"
        initialValue={false}
      >
        <Radio.Group>
          <Radio value>Yes</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      </Form.Item>
    </>
  );
}
